export enum SidebarActionTypes {
  SET_FILTER_STRING = 'Sidebar/SET_FILTER_STRING',
}
